import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { IFilterComponent, SearchFilter } from 'src/app/infrastructure/iFilter-component';
import { MatOption } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Plan, Entity } from 'src/app/model/entity';
import { FilterRecordService } from 'src/app/services/filter-record.service';
import { EntityService } from 'src/app/services/entity.service';
import { AuthService } from 'src/app/services/auth.service';
import { FilterService } from 'src/app/services/filter.service';
import { PhysicianFilter } from '../../../model/physician-Filter';
import { FilterCompleteService } from 'src/app/filter-complete/filter-complete';
import { MedicalFeeBillPeriodFilter } from '../../../model/medical-fee/medical-fee-bill-period-filter';
import { MedicalFeeStateFilter } from '../../../model/medical-fee/medical-fee-state-filter';
import { MedicalFeeControlService } from '../../../services/medical-fee/medical-fee-control.service';
import { MedicalFeeControlSearchItem } from '../../../model/medical-fee/medical-fee-control-search-item';
import { NotificationToastService } from 'src/app/services/notification-toast.service';

@Component({
  selector: 'app-medical-fee-control-filter',
  templateUrl: './medical-fee-control-filter.component.html',
  styleUrls: ['./medical-fee-control-filter.component.css']
})
export class MedicalFeeControlFilterComponent implements IFilterComponent, OnInit {

  form: FormGroup;
  @ViewChild('formElement', {static: false}) formElement: ElementRef;
  @ViewChild('allEntitySelected', {static: false}) private allEntitySelected: MatOption;

  filterCompleteMedicalFeeBillPeriod: FilterCompleteService<MedicalFeeBillPeriodFilter>;
  filterCompletePhysician: FilterCompleteService<PhysicianFilter>;
  filterCompleteEntity: FilterCompleteService<Entity>;
  filterCompletePlan: FilterCompleteService<Plan>;

  states: MedicalFeeStateFilter[] = [];

  // tslint:disable-next-line: no-output-on-prefix
  @Output() onInitSearch = new EventEmitter();

  constructor(private formBuilder: FormBuilder,
    private notificationToastService: NotificationToastService,
    private filterRecordService: FilterRecordService,
    private medicalFeeControlService: MedicalFeeControlService,
    private entityService: EntityService,
    private filterService: FilterService) {

      this.form = this.formBuilder.group({
        protocol: [ null ],
        physician: [ null ],
        period: [ null ],
        from: [ new Date()],
        to: [ new Date()],
        confirmatedFrom: [ null ],
        confirmatedTo: [ null ],
        entity: [ null ],
        plan: [ null ],
        states: [ [] ],
        medicalPreFeeBillId: [ null ],
        orderByPracticeRegion: [ false ]
      });

      this.filterCompleteEntity = new FilterCompleteService<Entity>([], this.form.controls.entity);
      this.filterCompletePlan = new FilterCompleteService<Plan>([], this.form.controls.plan);
      this.filterCompletePhysician = new FilterCompleteService<PhysicianFilter>([], this.form.controls.physician);
      this.filterCompleteMedicalFeeBillPeriod =
        new FilterCompleteService<MedicalFeeBillPeriodFilter>([], this.form.controls.period);

    }


  get f() { return this.form.controls; }

  get filteredPhysicianOptions() { return this.filterCompletePhysician ?
      this.filterCompletePhysician.filteredOptions : []; }

  get filteredEntityOptions() { return this.filterCompleteEntity ?
    this.filterCompleteEntity.filteredOptions : []; }

  get filteredPlanOptions() { return this.filterCompletePlan ?
    this.filterCompletePlan.filteredOptions : []; }

  get filterCompleteMedicalFeeBillPeriodOptions() { return this.filterCompleteMedicalFeeBillPeriod ?
    this.filterCompleteMedicalFeeBillPeriod.filteredOptions : []; }

  ngOnInit() {

    this.loadEntities();
    this.loadPhysicians();
    this.loadMedicalFeeBillPeriod();
    this.loadMedicalFeeStates();
  }

  private loadPhysicians() {
    this.filterService.getPhysiciansFilter().then( ( items ) => {
      this.filterCompletePhysician =
        new FilterCompleteService<PhysicianFilter>(items, this.form.controls.physician);
    });
  }

 private loadMedicalFeeStates() {

  this.filterService.getMedicalFeeStateFilters().then( (items) => {
    this.states = items;
    const filterEntities = this.filterRecordService
          .getFilterFromList<MedicalFeeStateFilter>('MedicalFeeControlFilterComponent', 'states', this.states);
    this.form.patchValue({
      entities: filterEntities
    });
  });
 }

 private loadMedicalFeeBillPeriod() {

  this.filterService.getMedicalFeeBillPeriodFilters().then( (items) => {
    this.filterCompleteMedicalFeeBillPeriod =
      new FilterCompleteService<MedicalFeeBillPeriodFilter>(items, this.form.controls.period);
  });
 }

  private loadEntities() {
    this.filterService.getEntitiesFilter().then( ( items ) => {
      this.filterCompleteEntity =  new FilterCompleteService<Entity>(items, this.form.controls.entity);
      this.form.controls.entity.valueChanges.subscribe(() => {
        this.loadPlans();
      });
    });
  }

  private loadPlans() {
    this.form.patchValue({ plan: null });
    this.filterCompletePlan = new FilterCompleteService<Plan>([], this.form.controls.plan);
    if (this.form.controls.entity.value) {
      const id = (<Entity>this.form.controls.entity.value).Id;
      this.entityService.getPlansByEntityId(id).then(info => {
        this.filterCompletePlan =
          new FilterCompleteService<Plan>(info, this.form.controls.plan);
      });
    }
  }

  async saveFilters() {
    this.filterRecordService.saveFilters('MedicalFeeControlFilterComponent', this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters('MedicalFeeControlFilterComponent', this.form);
  }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    return this.filterRecordService.convertToSearchFilters(this.form, requiredTags);
  }

  isValidFilter(): boolean {
    if ( !this.form.controls.protocol.value && !this.form.controls.physician.value ) {
      return false;
    } else {
      return true;
    }
  }

  async search(): Promise<MedicalFeeControlSearchItem[]> {
    if ( this.isValidFilter() ) {
      const items =  await this.medicalFeeControlService.getMedicalFeeControlSearchItems(
        (this.form.controls.protocol.value ? this.form.controls.protocol.value : ''),
        (this.form.controls.states.value ? (<MedicalFeeStateFilter[]>this.form.controls.states.value).map(p => p.Id) : null),
        (this.form.controls.physician.value ? this.form.controls.physician.value.Id : null),
        (this.form.controls.entity.value ? this.form.controls.entity.value.Id : null),
        (this.form.controls.plan.value ?   this.form.controls.plan.value.Id : null),
        (this.form.controls.from.value ? <Date>this.form.controls.from.value : null),
        (this.form.controls.to.value ? <Date>this.form.controls.to.value : null),
        (this.form.controls.medicalPreFeeBillId.value ? this.form.controls.medicalPreFeeBillId.value : null),
        (this.form.controls.period.value ? this.form.controls.period.value.Id : null),
        (this.form.controls.confirmatedFrom.value ? <Date>this.form.controls.confirmatedFrom.value : null),
        (this.form.controls.confirmatedTo.value ? <Date>this.form.controls.confirmatedTo.value : null),
        (this.form.controls.orderByPracticeRegion.value ?  this.form.controls.orderByPracticeRegion.value : false),
      );
      return items;
    } else {
      this.notificationToastService.error('Debe seleccionar un médico', 'Honorarios');
      return [];
    }
  }
}
